// src/features/employees/pages/CreateEmployeePage.tsx

import React from 'react';
import MainLayout from '@/components/layout/MainLayout';
import EmployeeForm from '../components/EmployeeForm';

const CreateEmployeePage = () => {
  return (
    <MainLayout>
      <div className="space-y-6 px-6 py-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Registrar nuevo empleado</h1>
          <p className="text-muted-foreground mt-1">
            Complete los campos requeridos para crear un nuevo empleado en el sistema.
          </p>
        </div>

        <EmployeeForm />
      </div>
    </MainLayout>
  );
};

export default CreateEmployeePage;
